import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames, log } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import queryString from "query-string";
import { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useCookies } from "react-cookie";
import Translate from "src/components/Translate";
import constants from "src/constants";
import gutter from "src/functions/gutter";
import isFormValid from "src/functions/isFormValid";
import onChangeToValue from "src/functions/onChangeToValue";
import translate from "src/functions/translate";
import Small_cancel from "src/icons/Small-cancel";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtonClose } from "src/styles/sButtonClose.module.scss";
import { sButtons } from "src/styles/sButtons.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sModal } from "src/styles/sModal.module.scss";
import { sModalAuth } from "src/styles/sModalAuth.module.scss";

type Props = {
  className?: (string | string) | null | undefined;
  openModalNewPassword: DynamicValue<boolean>;
  setAlertNewPassword: (setAlertNewPassword: boolean) => void;
};

function ModalNewPassword({
  className,
  openModalNewPassword,
  setAlertNewPassword,
}: Props) {
  const { locale: lang } = useRouter();
  const { push } = useRouter();
  var [password, setPassword] = useState("");
  var [passwordConfirmation, setPasswordConfirmation] = useState("");
  var [validated, setValidated] = useState(false);
  var [cookies, setCookie] = useCookies();
  const [failed, setFailed] = useState(false);
  const [closed, setClosed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  return (
    <Modal
      show={openModalNewPassword.value && !closed}
      className={composeClassNames([sModal, sModalAuth, "modal-password"])}
      size="sm"
      onHide={() => {
        openModalNewPassword.change(false);
      }}
      onExited={() => {
        if (typeof location !== "undefined") {
          let query = queryString.parse(location.search);
          delete query["pwdCode"];
          push({ query }, undefined, { shallow: true });
        }
      }}
    >
      <Modal.Header>
        <Modal.Title>
          <Translate tKey={`Set new password`} />
        </Modal.Title>
        <Button
          variant="link"
          onClick={function () {
            setClosed(true);
            return openModalNewPassword.change(false);
          }}
          size="sm"
          className={composeClassNames([sButtonClose, `btn-close`])}
        >
          <Small_cancel />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form id={`FormForgottenPassword`} validated={validated} noValidate>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`New password`} />
            </Form.Label>
            <Form.Control
              type={`password`}
              className={sFormControl}
              placeholder={translate(`Enter new password`, lang)}
              name={`password`}
              id={`password`}
              onChange={function (param2) {
                return setPassword(onChangeToValue(param2));
              }}
              value={password}
              required={true}
            />
            <Form.Control.Feedback type="invalid">
              <Translate tKey={constants.Form.mandatoryMessage} />
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label className={sFormLabel}>
              <Translate tKey={`Confirm password`} />
            </Form.Label>
            <Form.Control
              type={`password`}
              className={sFormControl}
              placeholder={translate(`Confirm new password`, lang)}
              name={`passwordConfirmation`}
              id={`passwordConfirmation`}
              onChange={function (param2) {
                return setPasswordConfirmation(onChangeToValue(param2));
              }}
              value={passwordConfirmation}
              required={true}
            />
            <Form.Control.Feedback type="invalid">
              <Translate tKey={constants.Form.mandatoryMessage} />
            </Form.Control.Feedback>
          </Form.Group>
          <div
            className={composeClassNames([sButtons, "buttons", "align-center"])}
          >
            <Button
              className={composeClassNames([sButton, "btn-submit"])}
              variant="primary"
              onClick={async function () {
                return await (async function iife() {
                  setValidated(true);
                  isFormValid(`FormForgottenPassword`) &&
                  password === passwordConfirmation
                    ? await (async function iife() {
                        var result = await (() =>
                          fetch(
                            `${constants.Paths.apiUrl}/auth/reset-password`,
                            {
                              body: JSON.stringify({
                                password,
                                passwordConfirmation,
                                code: queryString.parse(location.search)[
                                  "pwdCode"
                                ],
                              }),
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                            }
                          ).then(async (res) => {
                            if (res.ok) {
                              setClosed(true);
                              openModalNewPassword.change(false);
                              setAlertNewPassword(true);
                              const result = await res.json();
                              setCookie(
                                `auth-token`,
                                result.jwt,
                                constants.CookiesOptions
                              );
                              return result;
                            } else {
                              // throw new Error("API Error");
                              setFailed(true);
                              setErrorMessage(
                                `Password reset failed. Please try again.`
                              );
                            }
                          }))();
                        return log(result);
                      })()
                    : (() => {
                        password !== passwordConfirmation &&
                          (setFailed(true),
                          setErrorMessage(`Passwords do not match.`));
                      })();
                })();
              }}
            >
              <Translate tKey={`Set password`} />
            </Button>
            {failed && (
              <Alert
                variant="danger"
                className={sAlert}
                style={gutter(`margin`, `vertical`, `md`)}
              >
                <Translate tKey={errorMessage} />
              </Alert>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default ModalNewPassword;
